import { Fragment } from "react";
import moment from "moment";

import { references } from "common/helpers/references";

import { Placeholder } from "common/components/placeholder";

export function Breadcrumbs({
    buildHref,
    navigate,
    transferStatus,
    section
}) {
    const breadcrumbs = [
        {
            text: transferStatus === "settled" ? "Funds transferred: Net cash flow summary" : "Awaiting transfer: Net cash flow summary",
            displayParams: {
                display: {
                    view: "flat",
                    section: "all"
                },
                filters: ""
            }
        },
        {
            text: section.name,
            displayParams: {
                display: {
                    view: "flat",
                    section: section.alias
                },
                filters: ""
            }
        },
        {
            text: section.alt_name
        }
    ];
    return (
        <div className="drilldown-breadcrumbs">
            {breadcrumbs.map(({ text, displayParams }, index) => text && (
                <Fragment key={text}>
                    {index > 0 && <span>&gt;</span>}
                    {displayParams
                        ? (
                            <a
                                href={buildHref(displayParams)}
                                key={text}
                                onClick={(e) => {
                                    e.preventDefault();
                                    navigate(displayParams);
                                }}
                            >{text}
                            </a>
                        )
                        : <span key={text} >{text}</span>}
                </Fragment>
            ))}
        </div>
    );
}

export function BatchDetails({ batchData, dateType }) {
    if (!batchData) {
        return (
            <div className="batch-details">
                <Placeholder size="long" />
            </div>
        );
    }
    return (
        <div className="batch-details">
            <div className="header">
                <span>{references.toAlias(batchData?.acquirer, "5db9d5a782d84c6c839df36f")/* translate to references as `processor` field */}{(batchData?.acquiring_entity && `: ${batchData.acquiring_entity}`)}</span>
                <span>{dateType === "accepted_date" ? "Accepted date:" : "Settlement date:"}&nbsp;&nbsp;{batchData?.[dateType] ? moment(batchData[dateType]).format("MMM DD, YYYY") : "n/a"}</span>
            </div>
            <div className="info">
                Funds transfer group:
                {
                batchData?.["funds_transfer_groupings.company_id"] || batchData?.["funds_transfer_groupings.merchant_id"]
                    ? <span>{batchData?.["funds_transfer_groupings.company_id"] || batchData?.["funds_transfer_groupings.merchant_id"]}</span>
                    : null
                }
                {batchData?.["funds_transfer_groupings.bank_statement_narrative"] && <span>&nbsp;{batchData?.["funds_transfer_groupings.bank_statement_narrative"]}</span>}
                {batchData?.["funds_transfer_groupings.batch_id"] && <span>&nbsp;{batchData?.["funds_transfer_groupings.batch_id"]}</span>}
                {batchData?.["funds_transfer_groupings.store_id"] && <span>&nbsp;{batchData?.["funds_transfer_groupings.store_id"]}</span>}
            </div>
        </div>
    );
}
